import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AttorneyFullWidthSectionOne from '../../components/attorney-components/AttorneyFullWidthSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const AttorneyFullWidthOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Attorney Full Width 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Attorney Full Width 1"
        />
        
        <AttorneyFullWidthSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default AttorneyFullWidthOne;